import { useMemo, useState } from "react";
import TxModal from "components/modals/TxModal";
import { Card, SumCard } from "components/ui/index";
import { T } from "theme/index";
import { fmtShort } from "utils/format";


// ── Transaksi ─────────────────────────────────────────────────────────────────
export default function Transaksi({ transactions, categories, wallets, month, year, onAdd, onEdit, onDelete, openModal, setOpenModal }) {
  const [search,   setSearch]   = useState("");
  const [fType,    setFType]    = useState("all");
  const [fCat,     setFCat]     = useState("all");
  const [fWallet,  setFWallet]  = useState("all");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo,   setDateTo]   = useState("");
  const [showDateFilter, setShowDateFilter] = useState(false);

  const filtered = useMemo(() => transactions
    .filter(t => { const d=new Date(t.date); return d.getMonth()===month && d.getFullYear()===year; })
    .filter(t => fType==="all" || t.type===fType)
    .filter(t => fCat==="all" || t.categoryId===fCat)
    .filter(t => fWallet==="all" || t.walletId===fWallet || t.toWalletId===fWallet)
    .filter(t => !dateFrom || t.date >= dateFrom)
    .filter(t => !dateTo   || t.date <= dateTo)
    .filter(t => {
      if (!search) return true;
      const cat = categories.find(c=>c.id===t.categoryId);
      return (t.description||"").toLowerCase().includes(search.toLowerCase()) || (cat?.name||"").toLowerCase().includes(search.toLowerCase());
    })
    .sort((a,b)=>new Date(b.date)-new Date(a.date))
  ,[transactions,month,year,fType,fCat,fWallet,dateFrom,dateTo,search,categories]);

  const totalIn  = filtered.filter(t=>t.type==="income").reduce((a,t)=>a+t.amount,0);
  const totalOut = filtered.filter(t=>t.type==="expense").reduce((a,t)=>a+t.amount,0);
  const totalInv = filtered.filter(t=>t.type==="investasi").reduce((a,t)=>a+t.amount,0);
  const hasDateFilter = dateFrom || dateTo;

  const clearDates = () => { setDateFrom(""); setDateTo(""); };

  return (
    <div>
      {openModal && (
        <TxModal tx={openModal==="add"?null:openModal} categories={categories} wallets={wallets} onSave={openModal==="add"?onAdd:onEdit} onClose={() => setOpenModal(null)} />
      )}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(2,1fr)", gap:10, marginBottom:14 }}>
        <SumCard label="Masuk"     value={totalIn}  color={T.green} prefix="+" />
        <SumCard label="Keluar"    value={totalOut} color={T.red} />
        <SumCard label="Investasi" value={totalInv} color={T.gold} />
        <SumCard label="Bersih"    value={totalIn-totalOut-totalInv} color={(totalIn-totalOut-totalInv)>=0?T.green:T.red} prefix={(totalIn-totalOut-totalInv)>=0?"+":""} />
      </div>
      <Card style={{ padding:12, marginBottom:12 }}>
        {/* Search */}
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Cari transaksi..."
          style={{ width:"100%", background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, color:T.text, fontSize:14, padding:"10px 12px", outline:"none", boxSizing:"border-box", marginBottom:8 }}
        />
        {/* Filter row 1: tipe + kategori + tambah */}
        <div style={{ display:"flex", gap:8, marginBottom:8 }}>
          <select value={fType} onChange={e=>setFType(e.target.value)} style={{ flex:1, background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, color:T.text, fontSize:13, padding:"9px 8px", cursor:"pointer", outline:"none" }}>
            <option value="all">Semua Tipe</option>
            <option value="income">💰 Pemasukan</option>
            <option value="expense">💸 Pengeluaran</option>
            <option value="transfer">🔄 Transfer</option>
            <option value="investasi">📈 Investasi</option>
          </select>
          <select value={fCat} onChange={e=>setFCat(e.target.value)} style={{ flex:1, background:T.surface, border:`1px solid ${T.border}`, borderRadius:8, color:T.text, fontSize:13, padding:"9px 8px", cursor:"pointer", outline:"none" }}>
            <option value="all">Semua Kategori</option>
            {categories.map(c => <option key={c.id} value={c.id}>{c.icon} {c.name}</option>)}
          </select>
        </div>
        <button onClick={() => setOpenModal("add")}
          style={{ position:"fixed", bottom:24, right:20, width:52, height:52, borderRadius:"50%", background:T.gold, border:"none", color:T.bg, fontSize:24, fontWeight:700, cursor:"pointer", boxShadow:"0 4px 16px rgba(0,0,0,0.35)", zIndex:500, display:"flex", alignItems:"center", justifyContent:"center", WebkitTapHighlightColor:"transparent" }}>
          ＋
        </button>
        {/* Filter row 2: rekening */}
        {wallets.length > 0 && (
          <div style={{ marginBottom:8 }}>
            <select value={fWallet} onChange={e=>setFWallet(e.target.value)} style={{ width:"100%", background:T.surface, border:`1px solid ${fWallet!=="all"?T.gold:T.border}`, borderRadius:8, color:fWallet!=="all"?T.gold:T.text, fontSize:13, padding:"9px 10px", cursor:"pointer", outline:"none", fontWeight:fWallet!=="all"?700:400 }}>
              <option value="all">🏦 Semua Rekening</option>
              {wallets.map(w => <option key={w.id} value={w.id}>{w.icon} {w.name}</option>)}
            </select>
          </div>
        )}
        {/* Filter by date toggle */}
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <button onClick={() => setShowDateFilter(v=>!v)} style={{ background:"none", border:"none", color:hasDateFilter?T.gold:T.muted, cursor:"pointer", fontSize:12, fontWeight:600, display:"flex", alignItems:"center", gap:5, padding:0, WebkitTapHighlightColor:"transparent" }}>
            📅 Filter Tanggal {hasDateFilter && "✓"}
          </button>
          {hasDateFilter && <button onClick={clearDates} style={{ background:"none", border:"none", color:T.red, cursor:"pointer", fontSize:11, fontWeight:600, padding:0 }}>✕ Reset</button>}
        </div>
        {showDateFilter && (
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8, marginTop:8 }}>
            <div>
              <div style={{ color:T.muted, fontSize:10, fontWeight:600, marginBottom:4 }}>DARI TANGGAL</div>
              <input type="date" value={dateFrom} onChange={e=>setDateFrom(e.target.value)}
                style={{ width:"100%", background:T.surface, border:`1px solid ${dateFrom?T.gold:T.border}`, borderRadius:8, color:T.text, fontSize:13, padding:"8px 10px", outline:"none", boxSizing:"border-box" }}
              />
            </div>
            <div>
              <div style={{ color:T.muted, fontSize:10, fontWeight:600, marginBottom:4 }}>SAMPAI TANGGAL</div>
              <input type="date" value={dateTo} onChange={e=>setDateTo(e.target.value)}
                style={{ width:"100%", background:T.surface, border:`1px solid ${dateTo?T.gold:T.border}`, borderRadius:8, color:T.text, fontSize:13, padding:"8px 10px", outline:"none", boxSizing:"border-box" }}
              />
            </div>
          </div>
        )}
      </Card>
      <Card>
        {filtered.length===0 ? (
          <div style={{ padding:48, textAlign:"center", color:T.muted, fontSize:13 }}>Tidak ada transaksi ditemukan</div>
        ) : filtered.map((tx, idx) => {
          const cat    = categories.find(c=>c.id===tx.categoryId);
          const wallet = wallets.find(w=>w.id===tx.walletId);
          const toWallet = wallets.find(w=>w.id===tx.toWalletId);
          const isTransfer = tx.type === "transfer";
          return (
            <div key={tx.id} style={{ display:"flex", alignItems:"center", gap:10, padding:"11px 14px", borderBottom:idx<filtered.length-1?`1px solid ${T.border}`:"none" }}>
              <div style={{ width:38, height:38, borderRadius:9, fontSize:19, flexShrink:0, background:isTransfer?T.blue+"1E":(cat?.color||T.muted)+"1E", display:"flex", alignItems:"center", justifyContent:"center" }}>{isTransfer?"🔄":cat?.icon||"📌"}</div>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ color:T.text, fontSize:13, fontWeight:500, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                  {isTransfer ? `${wallet?.name||"?"} → ${toWallet?.name||"?"}` : tx.description||cat?.name||"Transaksi"}
                </div>
                <div style={{ display:"flex", gap:5, alignItems:"center", marginTop:2, flexWrap:"wrap" }}>
                  {!isTransfer && <span style={{ color:T.muted, fontSize:11 }}>{cat?.name} ·</span>}
                  {wallet && !isTransfer && <span style={{ background:wallet.color+"22", color:wallet.color, border:`1px solid ${wallet.color}33`, borderRadius:4, padding:"1px 5px", fontSize:10, fontWeight:700 }}>{wallet.icon} {wallet.name}</span>}
                  <span style={{ color:T.muted, fontSize:11 }}>{new Date(tx.date).toLocaleDateString("id-ID",{day:"numeric",month:"short"})}</span>
                </div>
              </div>
              <div style={{ textAlign:"right", flexShrink:0 }}>
                <div style={{ color:isTransfer?T.blue:tx.type==="income"?T.green:tx.type==="investasi"?T.gold:T.red, fontFamily:"monospace", fontVariantNumeric:"tabular-nums", fontWeight:700, fontSize:13 }}>
                  {isTransfer?"⇄":tx.type==="income"?"+":"-"}{fmtShort(tx.amount)}
                </div>
                <div style={{ display:"flex", gap:4, marginTop:4, justifyContent:"flex-end" }}>
                  <button onClick={() => setOpenModal(tx)} aria-label={`Edit transaksi ${tx.description || cat?.name || ""}`} style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:5, color:T.muted, cursor:"pointer", padding:"8px 10px", fontSize:12, minWidth:44, minHeight:44, WebkitTapHighlightColor:"transparent" }}>✏️</button>
                  <button onClick={() => { if(window.confirm("Hapus?")) onDelete(tx.id); }} aria-label={`Hapus transaksi ${tx.description || cat?.name || ""}`} style={{ background:T.red+"15", border:`1px solid ${T.red}28`, borderRadius:5, color:T.red, cursor:"pointer", padding:"8px 10px", fontSize:12, minWidth:44, minHeight:44, WebkitTapHighlightColor:"transparent" }}>🗑️</button>
                </div>
              </div>
            </div>
          );
        })}
      </Card>
    </div>
  );
}

// ── Anggaran ──────────────────────────────────────────────────────────────────
